import {useViewContext, deriveSelectedNodeFromSelection} from 'Contexts/ViewContext';
import {EnrichedAstNode, findParentOfNodeById} from 'rendition-core';

export const useSelectedParentNode = () => {
    const {selectedNodes, view} = useViewContext();
    const parents = selectedNodes
        .map((node) => findParentOfNodeById(view.tree, node.internalId))
        .filter(Boolean) as EnrichedAstNode[];
    return {parentNode: deriveSelectedNodeFromSelection(parents), parents: parents};
};
